module.exports = __webpack_public_path__ + "img/img2.a4dfc09e.jpg";